import React from "react";
import styled from "styled-components";

const GridItem = styled.div`
    border: lightgrey solid;
    border-width: 0 0.2px 0.2px 0.2px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
`;

const StickyGridItem = styled(GridItem)`
    position: sticky;
    z-index: 2;
    top: 0;
    background-color: white;
    height: 100%;
    flex-direction: column;

    &&& {
        min-width: 35px
    }
`;

const HeaderCarsView = ({
    onClick,
    index,
    dataDate,
    callBackCellRef,
    children
}) => (
        <StickyGridItem
            onClick={onClick}
            data-elementindex={index}
            data-date={dataDate}
            ref={callBackCellRef}
            className={["header-date"]}
        >
            {children}
        </StickyGridItem>
)

export default HeaderCarsView
